module.exports = __webpack_public_path__ + "b3481cb23f3f1528938ef133aeb0f8ca.png";